export const shouldRefreshReadForSocketMessage = (eventType, message, belongsToSelectedAgent) => (
  eventType === 'message.created'
  && ['staff', 'system'].includes(message?.sender_role)
  && belongsToSelectedAgent
);

export const shouldNotifyPlayerOfUnread = (previousCount, nextCount, chatOpen) => (
  previousCount !== null
  && nextCount > previousCount
  && !chatOpen
);

export const shouldDismissPlayerUnreadToast = (previousCount, nextCount) => (
  nextCount === 0
  || (previousCount !== null && nextCount < previousCount)
);

// Central GET history is read-only. ACK the rendered stream explicitly.
export const buildPlayerReadAcknowledgement = (messages, agent) => {
  const rendered = (Array.isArray(messages) ? messages : [])
    .filter(message => message?.id && !String(message.id).startsWith('temp_'));
  if (!rendered.some(message => message.sender_role !== 'player' && !message.read_by_player && !message.deleted)) return null;
  const sequenced = rendered.filter(message => Number.isInteger(message.sequence) && message.sequence >= 0);
  const boundary = sequenced.length
    ? sequenced.reduce((latest, message) => message.sequence > latest.sequence ? message : latest)
    : rendered[rendered.length - 1];
  return {
    last_message_id: String(boundary.id),
    rendered_message_ids: [...new Set(rendered.map(message => String(message.id)))],
    ...(agent?.id ? { agent_id: String(agent.id) } : {}),
    ...(agent?.name ? { agent_name: String(agent.name) } : {}),
  };
};
